export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/formular-bold-9bdd13dd64c845e210e876d8611578f5.woff2";